import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class NotificationService {
    constructor(private notifier: ToastrService) { }

    info(title: any, message = '') {
        if (message != '') {
            this.notifier.info(`${message}, ${title}`);
        } else {
            this.notifier.info(`${title}`);
        }
    }

    success(title: any, message = '') {
        if (message != '') {
            this.notifier.success(`${message}, ${title}`);
        } else {
            this.notifier.success(`${title}`);
        }
    }

    warning(title: any, message = '') {
        if (message != '') {
            this.notifier.warning(`${message}, ${title}`);
        } else {
            this.notifier.warning(`${title}`);
        }
    }

    error(title: any, message = '') {
        if (message != '') {
            this.notifier.error(`${message}, ${title}`);
        } else {
            this.notifier.error(`${title}`);
        }
    }
}
